import React, { useState } from 'react';
import { Offcanvas} from 'react-bootstrap';
import { collection, addDoc, increment, serverTimestamp, updateDoc, doc } from 'firebase/firestore';
import { db } from '../firebase/config';
import CommentsList from './CommentsList';
import { toastedError, toastedSuccess } from '../config/toast';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';


const CommentsOffcanvas = ({ show, handleClose, problemId, totalcomments }) => {
     const [text, setText] = useState('');
     const [loading, setLoading] = useState(false);

     const user = JSON.parse(localStorage.getItem('user'));

     // 🔥 Add comment
     const handleAddComment = async () => {
          if (!text.trim()) return;

          if (!user?.uid) {
               toastedError("Please login to add a comment.");
               return;
          }

          try {
               setLoading(true);

               await addDoc(collection(db, 'comments'), {
                    problemId,
                    userId: user.uid,
                    userName: user.name,
                    userInitials: user.name?.slice(0, 2).toUpperCase(),
                    text,
                    createdAt: serverTimestamp(),
               });

               const ref = doc(db, 'problems', problemId);

               await updateDoc(ref, {
                    comments: increment(1),
               });

               setText('');
               handleClose();

               // ✅ CLEAN MESSAGE
               toastedSuccess("Your comment has been added.");

          } catch (err) {
               console.error('Comment error:', err);
               toastedError("Failed to add comment.");
          } finally {
               setLoading(false);
          }
     };

     return (
          <Offcanvas show={show} onHide={handleClose} placement="end">
               <Tabs>

                    <Offcanvas.Header closeButton className='flex-column align-items-start'>
                         <Offcanvas.Title>Comments</Offcanvas.Title>
                         <span>{totalcomments} comments shared by the community</span>
                         <TabList>
                              <Tab>Write </Tab>
                              <Tab>Read</Tab>
                         </TabList>
                    </Offcanvas.Header>


                    <Offcanvas.Body>
                         
                         <TabPanel>
                              <div className="comment-input-box">
                                   <textarea
                                        rows={8}
                                        placeholder="Write a comment..."
                                        value={text}
                                        onChange={(e) => setText(e.target.value)}
                                   ></textarea>

                                   <button type='button'
                                        onClick={handleAddComment}
                                        disabled={loading}
                                        style={{ marginTop: '10px' }}
                                   >
                                        {loading ? 'Posting...' : 'Post Comment'}
                                   </button>
                              </div>
                         </TabPanel>
                         <TabPanel>
                              <CommentsList id={problemId} />
                         </TabPanel>

                    </Offcanvas.Body>
               </Tabs>
          </Offcanvas>
     );
};

export default CommentsOffcanvas;